import { ModalsSlice, UsersSlice } from '@hefe/store';
import { Form, Input, message, Space, Typography } from 'antd';
import { t } from '@hefe/i18n';
import React, { useState } from 'react';
import { useAppDispatch } from '../../../../store/store';

export default function InviteUsersForm() {
  const [form] = Form.useForm();
  const dispatch = useAppDispatch();

  const [validAddresses, setValidAddresses] = useState<string[]>([]);

  const checkValidAddresses = (text: string) => {
    const validateEmail = (email: string) => {
      const re =
        /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
      return re.test(String(email).toLowerCase());
    };

    const array = text.split('\n');
    const temp = new Set<string>();

    array.forEach((mail) => {
      if (validateEmail(mail)) {
        temp.add(mail);
      }
    });

    setValidAddresses(Array.from(temp));
  };

  const submit = () => {
    const setLoading = ModalsSlice.modalsActions.setModalLoading;
    dispatch(setLoading(true));
    dispatch(UsersSlice.inviteUsers(validAddresses))
      .unwrap()
      .then(() => {
        dispatch(ModalsSlice.modalsActions.closeModal());
        message.success(t('success.send_welcome_mail'));
        form.resetFields();
        setValidAddresses([]);
      })
      .catch(() => null)
      .finally(() => dispatch(setLoading(false)));
  };

  return (
    <Space direction="vertical">
      <Typography.Paragraph>{t('questions.invite_users')}</Typography.Paragraph>
      <Form
        id="invite-users"
        key="invite-users"
        form={form}
        onFinish={(values) => submit()}
      >
        <Form.Item
          name="emails"
          required={true}
          hasFeedback
          validateStatus={validAddresses.length > 0 ? 'success' : 'error'}
          rules={[
            {
              validator: (_, value) =>
                validAddresses.length > 0
                  ? Promise.resolve()
                  : Promise.reject(new Error(t('form_errors.email'))),
            },
          ]}
        >
          <Input.TextArea
            rows={4}
            onChange={(event) => checkValidAddresses(event.target.value)}
          />
        </Form.Item>
      </Form>
      <Typography.Paragraph>
        {t('information_texts.found_mail_addresses', {
          number: validAddresses.length,
        })}
      </Typography.Paragraph>
    </Space>
  );
}
